export const initialState = {
    searchResult:null,
    selectedResult:null,
    levels:[]
}